<template>
    <v-container id="response-billing-container">
        <v-row>
            <v-toolbar
                id="billing-code-toolbar"
                flat
                color="transparent"
            >
                <AddResponseBillingCode
                    :response-data="defaultResponseData"
                    model-type="Add"                    
                />
            </v-toolbar>
        </v-row>       
        <v-row v-if="!isResponseBillingCodesEmpty">
            <v-data-table
                :headers="computedHeaders"
                :items="filteredResponseBilling"
                hide-default-footer
                class="billing-data-table"
                dense
            >
                <template v-slot:[`item.code`]="{ item }">
                    {{ item.code.toUpperCase() }}
                </template>
                <template v-slot:[`item.quantity`]="{ item }">
                    {{ item.quantity }}
                </template>                
                <template v-slot:[`item.amount`]="{ item }">
                    <span v-if="showBillingAmount">
                        {{ item.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
                    </span>
                </template>                
                <template v-slot:[`item.minutes`]="{ item }">
                    {{ getBillingMinutesLabel(item.minutes) }}
                </template>
                <template v-slot:[`item.edit`]="{ item }">
                    <AddResponseBillingCode
                        :response-data="item" 
                        model-type="Edit" 
                    />
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                    <DeleteResponseBillingCode
                        :response-data="item" 
                        model-type="Delete"                       
                    />
                </template>
            </v-data-table>            
        </v-row>        
    </v-container>   
</template>
<script>
import CompanyBillingMixin from '@/mixins/CompanyBillingMixin';
import AddResponseBillingCode from './AddResponseBillingCode.vue';
import DeleteResponseBillingCode from './DeleteResponseBillingCode.vue';
import { guidEqual } from '@/utils/guid.js';

export default {
    components: {
        AddResponseBillingCode,
        DeleteResponseBillingCode,
    },
    mixins: [
        CompanyBillingMixin
    ],
    props: {
        responseId: {
            type: String,
            required: true,
        },
        billing: {
            type: Array,
            default: () => [],            
        },       
    },
    data() {
        return {
            headers: [
                { text: 'Code', value: 'code' },
                { text: 'Quantity', value: 'quantity'},
                { text: 'Amount', value: 'amount' },
                { text: 'Time Worked', value: 'minutes' },
                {
                    text: 'Edit',
                    align: 'center',
                    value: 'edit',
                    sortable: false,
                },
                {
                    text: 'Delete',
                    align: 'center',
                    value: 'delete',
                    sortable: false,
                }
            ],                     
        };
    },
    computed: {
        // remove amount from headers array if showBillingAmount is false
        computedHeaders() {
            let headers = this.headers;
            if (!this.showBillingAmount) {
                headers = headers.filter(item => item.value !== 'amount');
            }
            return headers;
        },
        isEmptyBillingCodes() {
            return this.billingCodes.length === 0;
        },
        isResponseBillingCodesEmpty() {
            return this.filteredResponseBilling.length === 0;
        },
        filteredResponseBilling() {
            return this.billing.filter(item => guidEqual(item.TR_rowid, this.responseId));
        },
        defaultResponseData() {
            return {
                TR_rowid: this.responseId                
            };
        },  
    },     
};
</script>

<style>
#response-billing-container .v-data-table {
     width: 60%;
     background-color: transparent;
     border: 0;
}
#response-billing-container .v-data-table table th {
    text-align: start;
    width: 30%;
    
}
#response-billing-container .v-data-table table td {
    text-align: start;
    width: 29%;
    white-space: nowrap;    
}
</style>
